import React, { useEffect, useMemo, useState } from "react";

// Import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { deleteWorkOrder, deleteWorkOrderRequest } from "store/actions";  // Replace with your delete action for work orders
import { formatDateTimeToAmPm } from "helpers/dateFormat_helper";
import Cookies from "js-cookie";

const WorkOrderReportTable = ({ 
  List, 
  loading, 
  isPagination = true, 
  docName,
  totalCount = 0,
  pageIndex = 0,
  pageSize = 10,
  sorting = [],
  onPaginationChange,
  onSortingChange,
  onGlobalFilterChange
}) => {
  const navigate = useNavigate();
   const location = useLocation();

  const permissions2 = JSON.parse(localStorage?.getItem('permissions')) || [];

  const handleNavigate = (workOrderId)=>{
    Cookies.set('endDate',localStorage?.getItem('endDate'));
    Cookies.set('startDate',localStorage?.getItem('startDate'));
    Cookies.set('selectedTeam',localStorage?.getItem('selectedTeam'));
    Cookies.set('selectedStatus',localStorage?.getItem('selectedStatus'));
    Cookies.set('pageUrl',localStorage.getItem('pageUrl'));
    Cookies.set('selectedSolution',localStorage.getItem('selectedSolution'));
    Cookies.set('createdAt',localStorage.getItem('createdAt'));
    navigate(`/workOrderDetails/${workOrderId}`,{ state: { path: location.pathname} })
  }
  const columns = useMemo(
    () => [
      {
        header: 'Work Order Number',
        accessorKey: 'workOrderNumber',
        enableColumnFilter: false,
        enableSorting: false,
        
        sortIndex: 0,
         cell: ({ row }) => {
           const permissionNames = permissions2?.map(item => item?.permissionName) || [];

          const canClick = permissionNames.includes("Work Order Details");
          return canClick ? (
           <span
              title="View Work Order"
              style={{ cursor: 'pointer', color: "rgb(4, 161, 182)" }}
              onClick={() =>handleNavigate(row.original?.workOrderId)}
            >
              {row.original.workOrderNumber}
            </span>
          ) : (
            <span style={{ color: "#666" }}>
              {row.original.workOrderNumber}
            </span>
          );
        },
      },
      {
        header: 'Team',
        accessorKey: 'teamName',
        enableColumnFilter: false,
        enableSorting: false,
        
        sortIndex: 1,
      },
      {
        header: 'CreatedBy',
        accessorKey: 'createdBy',
        enableColumnFilter: false,
        enableSorting: true,
        sortIndex: 2,
      },
      {
        header: 'Solution',
        accessorKey: 'solution',
        enableColumnFilter: false,
        enableSorting: false,
        sortIndex: 3,
        cell: ({ row }) => (
          <span >
            {row?.original?.solutionName}
          </span>
        ),
      },
      {
        header: 'Created At',
        accessorKey: 'createdAt',
        enableColumnFilter: false,
        enableSorting: true,
        sortIndex: 4,
        cell: ({ row }) => (
          <span>
            {formatDateTimeToAmPm(row.original.createdAt)}
          </span>
        ),
      },
      {
        header: 'Scheduled Start Date',
        accessorKey: 'scheduledStartDateTime',
        enableColumnFilter: false,
        enableSorting: true,
        sortIndex: 5,
        cell: ({ row }) => (
          <span>
            {formatDateTimeToAmPm(row.original.scheduledStartDateTime)}
          </span>
        ),
      },
      {
        header: 'Scheduled End Date',
        accessorKey: 'scheduledEndDateTime',
        enableColumnFilter: false,
        enableSorting: true,
        sortIndex: 6,
        cell: ({ row }) => (
          <span>
            {formatDateTimeToAmPm(row.original.scheduledEndDateTime)}
          </span>
        ),
      },
      {
        header: 'Status',
        accessorKey: 'workOrderStatus',
        enableColumnFilter: false,
        enableSorting: false,
        
        sortIndex: 7,
        cell: ({ getValue }) => getValue() || 'N/A',
      },
    ],
    [] // Re-run this useMemo when the permission changes
  );


  // Meta title for the page
  document.title = "Work Orders | Your Admin Dashboard";

  return (
    <>
      <div className="">
        <div className="container-fluid">
          {/* <Breadcrumbs title="Tables" breadcrumbItem="Work Orders" /> */}

          <TableContainer
            docName={docName}
            loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={false}
            isPagination={isPagination}
            SearchPlaceholder="Search..."
            pagination="pagination"
            paginationWrapper='dataTables_paginate paging_simple_numbers'
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            manualPagination={true}
            manualSorting={true}
            manualFiltering={true}
            totalCount={List && List.length > 0 ? List[0]?.TotalCount : totalCount}
            pageCount={List && List.length > 0 ? Math.ceil(List[0]?.TotalCount / pageSize) : Math.ceil(totalCount / pageSize)}
            onPaginationChange={onPaginationChange}
            onSortingChange={onSortingChange}
            onGlobalFilterChange={onGlobalFilterChange}
            paginationState={{ pageIndex, pageSize }}
            sortingState={sorting}
          />
        </div>
      </div>
    </>
  );
};

export default WorkOrderReportTable;
